import React, { useState, useRef, useEffect } from "react";
import { apiFetch } from "../api/apiFetch";

const PRESETS = [
  { key: "alle", label: "Alle" },
  { key: "sep-1", separator: true },
  { key: "huidige_week", label: "Huidige week" },
  { key: "huidige_14_dagen", label: "Huidige 14 dagen" },
  { key: "huidige_maand", label: "Huidige maand" },
  { key: "huidig_jaar", label: "Huidig jaar" },
  { key: "sep-2", separator: true },
  { key: "vorige_week", label: "Vorige week" },
  { key: "vorige_maand", label: "Vorige maand" },
  { key: "vorig_jaar", label: "Vorig jaar" },
  { key: "sep-3", separator: true },
  { key: "custom", label: "Aangepast" },
];

// De backend-presets-response gebruikt "huidige_jaar" als sleutel (consistent met
// huidige_week/huidige_maand); enkel het WEERGAVE-label is hier "Huidig jaar".
const PRESET_TO_RESPONSE_KEY = { huidig_jaar: "huidige_jaar", vorig_jaar: "vorige_jaar" };

// Dropdown met vooraf berekende datumbereiken (opgehaald bij /results/consultations/date-presets,
// zodat de boekje-week-logica (zaterdag-vrijdag) niet gedupliceerd wordt in JS). "preset" is
// controlled door de parent, zodat die weet wanneer (bij "Aangepast") de Van/Tot-velden als
// aparte filteritems ná deze picker getoond moeten worden, i.p.v. eronder.
export default function DateRangePresetPicker({ preset, onPresetChange, onChange }) {
  const [open, setOpen] = useState(false);
  const [presets, setPresets] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    apiFetch("/results/consultations/date-presets").then(setPresets).catch(() => {});
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectPreset = (key) => {
    onPresetChange(key);
    setOpen(false);
    if (key === "alle") {
      onChange("", "");
      return;
    }
    if (key === "custom") return;
    const responseKey = PRESET_TO_RESPONSE_KEY[key] || key;
    const range = presets?.[responseKey];
    if (range) onChange(range.date_from, range.date_to);
  };

  const activeLabel = PRESETS.find((p) => p.key === preset)?.label || "Periode kiezen";

  return (
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">Periode</label>
      <div className="relative" ref={ref}>
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="w-full border border-gray-300 rounded px-2 py-1.5 text-sm text-left bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 flex justify-between items-center gap-1"
        >
          <span className="truncate text-gray-700">{activeLabel}</span>
          <span className="text-gray-400 shrink-0">▾</span>
        </button>

        {open && (
          <div className="absolute left-0 top-full mt-1 z-20 bg-white border border-gray-200 rounded-lg shadow-lg p-1 w-max min-w-[200px]">
            {PRESETS.map((p) =>
              p.separator ? (
                <div key={p.key} className="my-1 border-t border-gray-100" />
              ) : (
                <button
                  key={p.key}
                  type="button"
                  onClick={() => selectPreset(p.key)}
                  className={`block w-full text-left px-2 py-1.5 text-sm rounded hover:bg-gray-50 ${
                    preset === p.key ? "bg-blue-50 text-blue-700" : "text-gray-700"
                  }`}
                >
                  {p.label}
                </button>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
}
